import { toast } from 'react-toastify';
import API from '../apiClient';
import { handleApiError } from '../Utils/errorHandler';

// for list of project
export const GetProjectData = (org_id) => {
    return new Promise((resolve,reject) => {
        API.get(`/project/?organization_id=${encodeURIComponent(org_id)}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          const errorResult = handleApiError(error, 'Fail to Get All Project Data', { organization_id: org_id });
          reject(errorResult);
        }); 
    });
};

export const GetProjectDataById = (projectId) => {
    return new Promise((resolve,reject) => {
        API.get(`/project/${encodeURIComponent(projectId)}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          const errorResult = handleApiError(error, 'Fail to Get Project Data', { project_id: projectId });
          reject(errorResult);
        }); 
    });
};

//add project
export const addProject = (payload) => {
  return new Promise((resolve,reject) => {
      API.post(`/project`, payload)
      .then(response => {
          resolve(response);
      }) .catch(error =>{
          const errorResult = handleApiError(error, 'Fail to Create Project');
          reject(errorResult);
      });
  });
};

// delete project
export const deleteProject = (projectId) => {
  return new Promise((resolve,reject) => {
      API.post(`/project/${encodeURIComponent(projectId)}`)
      .then(response => {
          resolve(response);
      }) .catch(error =>{
          const errorResult = handleApiError(error, 'Fail to Delete Project', { project_id: projectId });
          reject(errorResult);
      });
  });
};

//update project
export const updateProject = (projectId,payload) => {
  return new Promise((resolve,reject) => {
    API.put(`/project/${encodeURIComponent(projectId)}`,payload)
      .then(response => {
        resolve(response); 
      })
      .catch(error =>{
        const errorResult = handleApiError(error, 'Fail to Update Project', { project_id: projectId });
        reject(errorResult);
      }); 
  });
};
 











